import { useEffect, useState, useRef } from "react";
import AdminTopNavBar from "../common/AdminTopNavBar";
import getUserMenuItems from "./AdminMenuContent";
import AdminSideBar from "./AdminSideBar";
import { adminReqConfig, api, baseURL } from "../../include/api";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AdminFooter from "../common/AdminFooter";
import { useNotification } from "../../Toast/ToastProvider";
import { ERROR } from "../../include/constant";
import { ChevronDown, X } from "react-feather";
import Papa from "papaparse";
import "../../styles/CategoryProductList.css";
import { getAdmin } from "../../include/function";
import { useSearchParams } from "react-router-dom";

const ReportProduct = () => {
  const homeLink = "/admin";
  const [fetchLoading, setFetchLoading] = useState(true);
  const [productList, setProductList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const toggleSidebar = () => setIsSidebarMinimized(!isSidebarMinimized);
  const menuContent = getUserMenuItems();
  const toast = useNotification();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [allBrands, setAllBrands] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get("q") || "";
  const [searchQuery, setSearchQuery] = useState(initialQuery);

  useEffect(() => {
    const q = searchParams.get("q") || "";
    setSearchQuery(q);
  }, [searchParams]);

  const [filterValues, setFilterValues] = useState({
    productId: "",
    brandId: "",
    categoryId: "",
  });

  const user = getAdmin();
  const [productPermissions, setProductPermissions] = useState({
    add: false,
    view: false,
    edit: false,
    delete: false,
  });

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user?.roleId) return;

      try {
        const res = await api.get(
          `/role_permission/?roleId=${user.roleId}`,
          adminReqConfig(),
        );
        if (res.status === 200 && Array.isArray(res.data.data)) {
          const productPerm = res.data.data.find(
            (p) => p.pageTitle === "Report Products",
          );

          if (productPerm) {
            setProductPermissions({
              add: productPerm.add === "true" || productPerm.add === 1,
              view: productPerm.view === "true" || productPerm.view === 1,
              edit: productPerm.edit === "true" || productPerm.edit === 1,
              delete: productPerm.delete === "true" || productPerm.delete === 1,
            });
          }
        }
      } catch (err) {
        console.warn("Failed to fetch product permissions", err);
      }
    };

    fetchPermissions();
  }, [user?.roleId]);

  const filterWrapperRef = useRef(null);

  const getCategory = () => {
    setFetchLoading(true);
    Promise.all([
      api.get("/product/", adminReqConfig()),
      api.get("/brand/", adminReqConfig()),
      api.get("/category/?flag=exceptHome", adminReqConfig()),
    ])
      .then(([productRes, brandRes, categoryRes]) => {
        const rawProducts = productRes.data.data || [];
        const allBrandList = brandRes.data.data || [];
        const allCategoryList = categoryRes.data.data || [];

        setBrands(allBrandList);
        setCategories(allCategoryList);
        setAllBrands(allBrandList);
        setAllCategories(allCategoryList);

        const normalizedProducts = rawProducts.map((p) => {
          let brandId = p.brandId != null ? parseInt(p.brandId) : null;
          let categoryId = p.categoryId != null ? parseInt(p.categoryId) : null;

          if (brandId == null && p.brandName) {
            const brandMatch = allBrandList.find(
              (b) => b.name?.toLowerCase() === p.brandName.toLowerCase(),
            );
            brandId = brandMatch ? brandMatch.id : null;
          }

          if (categoryId == null && p.categoryName) {
            const catMatch = allCategoryList.find(
              (c) => c.name?.toLowerCase() === p.categoryName.toLowerCase(),
            );
            categoryId = catMatch ? catMatch.id : null;
          }

          return {
            ...p,
            brandId,
            categoryId,
          };
        });

        setProductList(normalizedProducts);
        setFilteredData(normalizedProducts);
      })
      .catch((error) => {
        toast({ type: ERROR, message: "Error fetching product data" }, error);
        setProductList([]);
        setFilteredData([]);
        setBrands([]);
        setCategories([]);
      })
      .finally(() => setFetchLoading(false));
  };

  useEffect(() => {
    getCategory();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isFilterPanelOpen &&
        filterWrapperRef.current &&
        !filterWrapperRef.current.contains(event.target)
      ) {
        setIsFilterPanelOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isFilterPanelOpen]);

  const applyFilters = () => {
    setIsFilterPanelOpen(false);
  };

  const clearFilters = () => {
    const empty = {
      productId: "",
      brandId: "",
      categoryId: "",
    };
    setFilterValues(empty);
    setIsFilterPanelOpen(false);
  };

  const filteredBrands = filterValues.categoryId
    ? brands.filter((brand) =>
        productList.some(
          (p) =>
            p.categoryId === parseInt(filterValues.categoryId) &&
            p.brandId === brand.id,
        ),
      )
    : brands;

  const filteredProducts = filterValues.brandId
    ? productList.filter(
        (p) =>
          p.brandId === parseInt(filterValues.brandId) &&
          (!filterValues.categoryId ||
            p.categoryId === parseInt(filterValues.categoryId)),
      )
    : filterValues.categoryId
      ? productList.filter(
          (p) => p.categoryId === parseInt(filterValues.categoryId),
        )
      : productList;

  useEffect(() => {
    let filtered = productList;

    if (filterValues.brandId) {
      filtered = filtered.filter(
        (product) => product.brandId === parseInt(filterValues.brandId),
      );
    }

    if (filterValues.categoryId) {
      filtered = filtered.filter(
        (product) => product.categoryId === parseInt(filterValues.categoryId),
      );
    }

    if (filterValues.productId) {
      filtered = filtered.filter(
        (product) => product.id === parseInt(filterValues.productId),
      );
    }

    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      filtered = filtered.filter(
        (product) =>
          product.name?.toLowerCase().startsWith(query) ||
          product.categoryName?.toLowerCase().startsWith(query) ||
          product.brandName?.toLowerCase().startsWith(query),
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [filterValues, searchQuery, productList, searchParams]);

  const formatProductId = (productList) => {
    if (!productList?.createdAt || !productList?.id) return "PROD--";

    const year = new Date(productList.createdAt).getFullYear();
    const yy = String(year).slice(-2);
    const paddedId = String(productList.id).padStart(4, "0");
    const catId = String(productList.categoryId).padStart(2, "0");

    return `PROD${yy}-C${catId}-${paddedId}`;
  };

  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;

  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = currentItems.map((p) => p.id);
      setSelectedData((prev) => [...new Set([...prev, ...allIds])]);
    } else {
      const idsToRemove = currentItems.map((p) => p.id);
      setSelectedData((prev) =>
        prev.filter((id) => !idsToRemove.includes(id)),
      );
    }
  };

  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id],
    );
  };

const handleDownloadCSV = (exportScope = "current") => {
  let dataToExport = [];

  if (selectedData.length > 0) {
    dataToExport = productList.filter((p) => selectedData.includes(p.id));
  } 
  // ✅ PRIORITY 2: If "Export All" clicked → export entire dataset
  else if (exportScope === "all") {
    dataToExport = productList;
  } 
  // ✅ PRIORITY 3: Default → export current page items only
  else {
    dataToExport = currentItems;
  }

  if (dataToExport.length === 0) {
    toast({ type: "error", message: "No product data to download" });
    return;
  }

  const productColumns = [
    "S.No",
    "Product ID",
    "Name",
    "Brand Name",
    "Category Name",
    "Description",
    "Highlight",
    "Retail Price",
    "B2B Price",
    "B2C Price",
    "B2bFlag",
    "B2cFlag",
    "B2bDiscountMode",
    "B2bDiscountValue",
    "B2cDiscountMode",
    "B2cDiscountValue",
    "WarrentyMode",
    "WarrentyPeriod",
    "WarrentyLabel",
    "Grade",
    "Type",
    "Certification",
    "tax",
    "cgst",
    "sgst",
    "DeliveryCharge",
    "Status",
    "Quantity & Price Tiers",
    "Specifications",
    "Steel Variants",
    "Extra Images",
    "Main Image",
  ];

  const csvData = dataToExport.flatMap((p, i) => {
    const isSteel = (p.categoryName || "").toLowerCase() === "steel";
    const hasVariants =
      Array.isArray(p.productVariant) && p.productVariant.length > 0;
    let retailPriceDisplay = "N/A";
    let b2bPriceDisplay = "N/A";
    let b2cPriceDisplay = "N/A";

    if (!isSteel) {
      const price = parseFloat(p.price) || 0;
      retailPriceDisplay = `Rs.${price.toFixed(2)}`;
      const b2bDiscountValue = parseFloat(p.b2bDiscountValue) || 0;
      const b2cDiscountValue = parseFloat(p.b2cDiscountValue) || 0;
      const b2bMode = (p.b2bDiscountMode || "").toLowerCase();
      const b2cMode = (p.b2cDiscountMode || "").toLowerCase();

      const b2bPrice =
        b2bMode === "percent"
          ? price - (b2bDiscountValue / 100) * price
          : price - b2bDiscountValue;

      const b2cPrice =
        b2cMode === "percent"
          ? price - (b2cDiscountValue / 100) * price
          : price - b2cDiscountValue;

      b2bPriceDisplay = `Rs.${b2bPrice.toFixed(2)}`;
      b2cPriceDisplay = `Rs.${b2cPrice.toFixed(2)}`;
    } else {
      retailPriceDisplay = "See Variants";
      b2bPriceDisplay = "See Variants";
      b2cPriceDisplay = "See Variants";
    }

    const qtyPriceRows =
      p.qtyAndPrice && Array.isArray(p.qtyAndPrice) ? p.qtyAndPrice : [];
    const qtyPriceStrings = qtyPriceRows
      .map(
        (qp) =>
          `Rs.${qp.price} for ${qp.minQty}-${qp.maxQty} (${qp.basedOn})`,
      )
      .join(" | ");

    const specRows =
      p.productSpecification && Array.isArray(p.productSpecification)
        ? p.productSpecification
        : [];
    const specStrings = specRows
      .map((spec) => `${spec.title}: ${spec.description}`)
      .join(" | ");

    const steelVariantStrings =
      isSteel && hasVariants
        ? p.productVariant
            .map((v) => {
              const parts = [`Dia: ${v.title}`];
              const retail = parseFloat(v.price) || 0;
              parts.push(`Retail: Rs.${retail.toFixed(2)}`);

              if (v.b2cDiscountMode) {
                const b2cMode = (v.b2cDiscountMode || "").toLowerCase();
                const b2cFinal =
                  b2cMode === "percent"
                    ? retail -
                      (parseFloat(v.b2cDiscountValue || 0) / 100) * retail
                    : retail - parseFloat(v.b2cDiscountValue || 0);
                parts.push(
                  `B2C: Rs.${b2cFinal.toFixed(2)} (${v.b2cDiscountValue} ${v.b2cDiscountMode})`,
                );
              }

              if (v.b2bDiscountMode) {
                const b2bMode = (v.b2bDiscountMode || "").toLowerCase();
                const b2bFinal =
                  b2bMode === "percent"
                    ? retail -
                      (parseFloat(v.b2bDiscountValue || 0) / 100) * retail
                    : retail - parseFloat(v.b2bDiscountValue || 0);
                parts.push(
                  `B2B: Rs.${b2bFinal.toFixed(2)} (${v.b2bDiscountValue} ${v.b2bDiscountMode}) Rate: ${v.rateValue || "N/A"} ${v.priceDiff || ""}`,
                );
              }

              return parts.join(", ");
            })
            .join(" | ")
        : isSteel
          ? "No variants"
          : "";

    const extraImageUrls =
      p.images && Array.isArray(p.images)
        ? p.images.map((img) => baseURL + "/" + img.imageUrl).join(", ")
        : "";

    const baseRow = {
      "S.No": i + 1,
      "Product ID": formatProductId(p),
      Name: p.name || "-",
      "Brand Name": p.brandName || "N/A",
      "Category Name": p.categoryName || "N/A",
      Description: p.description?.replace(/<[^>]*>/g, "") || "-",
      Highlight: p.highlight?.replace(/<[^>]*>/g, "") || "-",
      "Retail Price": retailPriceDisplay,
      "B2B Price": b2bPriceDisplay,
      "B2C Price": b2cPriceDisplay,
      B2bFlag: p.b2bFlag ? "Yes" : "No",
      B2cFlag: p.b2cFlag ? "Yes" : "No",
      B2bDiscountMode: p.b2bDiscountMode || "-",
      B2bDiscountValue: p.b2bDiscountValue || 0,
      B2cDiscountMode: p.b2cDiscountMode || "-",
      B2cDiscountValue: p.b2cDiscountValue || 0,
      WarrentyMode: p.warrantyMode || "-",
      WarrentyPeriod: p.warrantyPeriod || "-",
      WarrentyLabel: p.warrantyLabel || "-",
      Grade: p.grade || "-",
      Type: p.type || "-",
      Certification: p.certification || "-",
      tax: p.tax || 0,
      cgst: p.cgst || 0,
      sgst: p.sgst || 0,
      DeliveryCharge: p.deliveryCharge || 0,
      Status: p.status || "-",
      "Quantity & Price Tiers": qtyPriceStrings || "-",
      Specifications: specStrings || "-",
      "Steel Variants": steelVariantStrings || "",
      "Extra Images": extraImageUrls || "-",
      "Main Image": p.mainImage ? baseURL + "/" + p.mainImage : "-",
    };

    return [baseRow];
  });

  // ✅ CRITICAL FIX: The word "data" followed by colon, then the mapping
  const csv = Papa.unparse({
    fields: productColumns,
    data: csvData.map(function(row) {
      return productColumns.map(function(col) {
        return row[col];
      });
    }),
  });

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  
  // ✅ Dynamic filename based on export type
  const fileName = selectedData.length > 0 
    ? `Product_Selected_${selectedData.length}.csv`
    : exportScope === "all" 
      ? "Product_All.csv" 
      : `Product_Page${currentPage}.csv`;
    
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  const stripHtml = (str) => (str || "").replace(/<[^>]*>/g, "") || "-";

  const generateProductPDF = async (product, baseURL) => {
    const doc = new jsPDF();
    let imgHeight = 0;

    if (product.mainImage) {
      const imgUrl = `${baseURL}/${product.mainImage}`;
      try {
        const imgData = await fetch(imgUrl)
          .then((res) => res.blob())
          .then(
            (blob) =>
              new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              }),
          );

        const imgProps = doc.getImageProperties(imgData);
        const imgRatio = imgProps.width / imgProps.height;
        const imgWidth = 25;
        imgHeight = imgWidth / imgRatio;
        if (imgHeight > 25) imgHeight = 25;

        const pageWidth = 210;
        const rightMargin = 10;
        const imgX = pageWidth - imgWidth - rightMargin;
        const imgY = 5;
        doc.addImage(imgData, "JPEG", imgX, imgY, imgWidth, imgHeight);
      } catch (err) {
        console.warn("Failed to load product image for PDF:", err);
      }
    }

    const titleY = 20;
    doc.setFontSize(16);
    doc.text(`Product Report: ${product.name}`, 14, titleY);
    doc.setFontSize(10);

    const isSteel = (product.categoryName || "").toLowerCase() === "steel";
    const hasVariants =
      Array.isArray(product.productVariant) &&
      product.productVariant.length > 0;
    let retailPriceDisplay = "N/A";
    let b2bPriceDisplay = "N/A";
    let b2cPriceDisplay = "N/A";

    if (!isSteel) {
      const price = parseFloat(product.price) || 0;
      retailPriceDisplay = `Rs.${price.toFixed(2)}`;
      const b2bDiscountValue = parseFloat(product.b2bDiscountValue) || 0;
      const b2cDiscountValue = parseFloat(product.b2cDiscountValue) || 0;
      const b2bMode = (product.b2bDiscountMode || "").toLowerCase();
      const b2cMode = (product.b2cDiscountMode || "").toLowerCase();

      const b2bPrice =
        b2bMode === "percent"
          ? price - (b2bDiscountValue / 100) * price
          : price - b2bDiscountValue;

      const b2cPrice =
        b2cMode === "percent"
          ? price - (b2cDiscountValue / 100) * price
          : price - b2cDiscountValue;

      b2bPriceDisplay = `Rs.${b2bPrice.toFixed(2)}`;
      b2cPriceDisplay = `Rs.${b2cPrice.toFixed(2)}`;
    } else {
      retailPriceDisplay = "See Variants";
      b2bPriceDisplay = "See Variants";
      b2cPriceDisplay = "See Variants";
    }

    const qtyPriceRows = Array.isArray(product.qtyAndPrice)
      ? product.qtyAndPrice
      : [];
    const qtyPriceText =
      qtyPriceRows
        .map(
          (qp) =>
            `Rs.${qp.price} for ${qp.minQty}-${qp.maxQty} (${qp.basedOn})`,
        )
        .join("\n") || "-";

    const specRows = Array.isArray(product.productSpecification)
      ? product.productSpecification
      : [];
    const specText =
      specRows.map((spec) => `${spec.title}: ${spec.description}`).join("\n") ||
      "-";

    const steelVariantText =
      isSteel && hasVariants
        ? product.productVariant
            .map((v) => {
              const parts = [`Dia: ${v.title}`];
              const retail = parseFloat(v.price) || 0;
              parts.push(`Retail: Rs.${retail.toFixed(2)}`);

              if (v.b2cDiscountMode) {
                const b2cMode = (v.b2cDiscountMode || "").toLowerCase();
                const b2cFinal =
                  b2cMode === "percent"
                    ? retail -
                      (parseFloat(v.b2cDiscountValue || 0) / 100) * retail
                    : retail - parseFloat(v.b2cDiscountValue || 0);
                parts.push(
                  `B2C: Rs.${b2cFinal.toFixed(2)} (${v.b2cDiscountValue} ${v.b2cDiscountMode})`,
                );
              }

              if (v.b2bDiscountMode) {
                const b2bMode = (v.b2bDiscountMode || "").toLowerCase();
                const b2bFinal =
                  b2bMode === "percent"
                    ? retail -
                      (parseFloat(v.b2bDiscountValue || 0) / 100) * retail
                    : retail - parseFloat(v.b2bDiscountValue || 0);
                parts.push(
                  `B2B: Rs.${b2bFinal.toFixed(2)} (${v.b2bDiscountValue} ${v.b2bDiscountMode}) Rate: ${v.rateValue || "N/A"} ${v.priceDiff || ""}`,
                );
              }

              return parts.join(", ");
            })
            .join("\n")
        : isSteel
          ? "No variants"
          : "";

    const extraImageUrls = Array.isArray(product.images)
      ? product.images.map((img) => `${baseURL}/${img.imageUrl}`).join("\n")
      : "-";

    const tableData = [
      ["Field", "Value"],
      ["Product ID", formatProductId(product)],
      ["Name", product.name || "-"],
      ["Brand Name", product.brandName || "N/A"],
      ["Category Name", product.categoryName || "N/A"],
      ["Description", stripHtml(product.description)],
      ["Highlight", stripHtml(product.highlight)],
      ["Retail Price", retailPriceDisplay],
      ["B2B Price", b2bPriceDisplay],
      ["B2C Price", b2cPriceDisplay],
      ["B2B Enabled", product.b2bFlag ? "Yes" : "No"],
      ["B2C Enabled", product.b2cFlag ? "Yes" : "No"],
      ["B2B Discount Mode", product.b2bDiscountMode || "-"],
      ["B2B Discount Value", product.b2bDiscountValue || "0"],
      ["B2C Discount Mode", product.b2cDiscountMode || "-"],
      ["B2C Discount Value", product.b2cDiscountValue || "0"],
      ["Warranty Mode", product.warrantyMode || "-"],
      ["Warranty Period", product.warrantyPeriod || "-"],
      ["Warranty Label", product.warrantyLabel || "-"],
      ["Grade", product.grade || "-"],
      ["Type", product.type || "-"],
      ["Certification", product.certification || "-"],
      ["Tax (%)", product.tax || "0"],
      ["CGST (%)", product.cgst || "0"],
      ["SGST (%)", product.sgst || "0"],
      ["Delivery Charge", product.deliveryCharge || "0"],
      ["Status", product.status || "-"],
      ["Quantity & Price Tiers", qtyPriceText],
      ["Specifications", specText],
      ["Steel Variants", steelVariantText],
      ["Extra Images", extraImageUrls],
      [
        "Main Image URL",
        product.mainImage ? `${baseURL}/${product.mainImage}` : "-",
      ],
    ];

    const tableStartY = titleY + 10;
    autoTable(doc, {
      startY: tableStartY,
      head: [["Field", "Value"]],
      body: tableData.slice(1),
      theme: "grid",
      styles: { fontSize: 10, cellPadding: 1.5 },
      headStyles: { fillColor: [43, 149, 211], fontSize: 11 },
      columnStyles: {
        0: { cellWidth: 60, fontStyle: "bold" },
        1: { cellWidth: 130, overflow: "linebreak" },
      },
      margin: { left: 14, right: 14 },
    });

    const finalY = doc.previousAutoTable.finalY + 10;
    const timestamp = `Generated on: ${new Date().toLocaleString("en-IN", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    })}`;

    if (finalY > 270) {
      doc.addPage();
      doc.text(timestamp, 14, 20);
    } else {
      doc.text(timestamp, 14, finalY);
    }

    const safeName = (product.name || "product")
      .replace(/\s+/g, "_")
      .replace(/[^a-zA-Z0-9_-]/g, "");
    doc.save(`product_${product.id}_${safeName}.pdf`);
  };

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => {
      const updated = { ...prev, [key]: value };
      if (key === "categoryId") {
        updated.brandId = "";
        updated.productId = "";
      } else if (key === "brandId") {
        updated.productId = "";
      }
      return updated;
    });
  };

  return (
    <>
      <AdminSideBar
        menuContent={menuContent}
        isMinimized={isSidebarMinimized}
      />
      <AdminTopNavBar
        toggleSidebar={toggleSidebar}
        isSidebarMinimized={isSidebarMinimized}
        homeLink={homeLink}
        title="REPORTS"
      />
      <div
        className="content-wrapper p-0"
        style={{
          marginLeft: isSidebarMinimized ? "80px" : "250px",
          flex: "1",
        }}
      >
        <section
          style={{
            backgroundColor: "#F1F4F9",
            padding: "30px",
            marginTop: "70px",
            marginBottom: "40px",
            minHeight: "80vh",
          }}
        >
          {fetchLoading ? (
            <p>Loading products...</p>
          ) : (
            <>
              <div className="rounded-5 bg-white py-24 ">
                <div className="row align-items-center px-24 py-10 mb-3">
                  <div className="col-auto">
                    <h6 className="mb-0">Product List</h6>
                  </div>
                  <div className="col d-flex align-items-center">
                    <div
                      className="filter-wrapper"
                      style={{ position: "relative", width: "500px" }}
                      ref={filterWrapperRef}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #c6d6f5",
                          borderRadius: "8px",
                          backgroundColor: "#fff",
                          width: "100%",
                        }}
                      >
                        <img
                          src="/assets/images/search-icon.png"
                          style={{ width: "18px", marginLeft: "8px" }}
                        />
                        <input
                          type="text"
                          placeholder="Filter and search here..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          onFocus={() => setIsFilterPanelOpen(true)}
                          style={{
                            border: "none",
                            outline: "none",
                            padding: "8px 8px",
                            width: "100%",
                            fontSize: "14px",
                            color: "#333",
                            backgroundColor: "transparent",
                          }}
                        />
                        {searchQuery && (
                          <X
                            size={24}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSearchQuery("");
                              setCurrentPage(1);
                              setIsFilterPanelOpen(false);
                            }}
                            style={{
                              position: "absolute",
                              right: "40px",
                              cursor: "pointer",
                              color: "#999",
                              padding: "4px",
                              zIndex: 10,
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.color = "#666")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.color = "#999")
                            }
                          />
                        )}
                        <ChevronDown
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#999",
                            cursor: "pointer",
                            transform: isFilterPanelOpen
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsFilterPanelOpen(!isFilterPanelOpen);
                          }}
                        />
                      </div>

                      {isFilterPanelOpen && (
                        <FilterPanel
                          filterValues={filterValues}
                          onFilterChange={handleFilterChange}
                          onApply={applyFilters}
                          onClear={clearFilters}
                          brands={filteredBrands}
                          categories={categories}
                          products={filteredProducts}
                          onClick={(e) => e.stopPropagation()}
                        />
                      )}
                    </div>
                  </div>
                  <div className="d-flex col-auto">
                    <div className="">
                      <CustomDropdown handleDownloadCSV={handleDownloadCSV} />
                    </div>
                  </div>
                </div>

                <div className="table-responsive mt-24 product-table">
                  <table className="table table-striped custom-striped-table-product-list align-middle">
                    <thead className="">
                      <tr>
                        <th scope="col" style={{ width: "50px" }}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ borderColor: "#c5d5f5" }}
                            onChange={handleSelectAll}
                            checked={
                              currentItems.length > 0 &&
                              currentItems.every((p) =>
                                selectedData.includes(p.id),
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Product ID
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Product Name
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Category
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Brand
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Product Price
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          B2b Selling Price
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          B2c Selling Price
                        </th>
                        <th
                          scope="col"
                          style={{
                            width: "120px",
                            fontSize: "15px",
                          }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((product) => {
                          const isSteel =
                            product.categoryName &&
                            (product.categoryName.toLowerCase() === "steel" ||
                              product.categoryName.toLowerCase() === "steels");
                          let productPriceDisplay = "0";
                          let b2bPriceDisplay = "0";
                          let b2cPriceDisplay = "0";

                          if (
                            isSteel &&
                            Array.isArray(product.productVariant) &&
                            product.productVariant.length > 0
                          ) {
                            const variantPrices = product.productVariant
                              .map((v) => parseFloat(v.price))
                              .filter((p) => !isNaN(p));

                            const b2bPrices = product.productVariant
                              .map((v) => {
                                const base = parseFloat(v.price);
                                if (isNaN(base)) return null;
                                const b2bMode = (
                                  v.b2bDiscountMode || ""
                                ).toLowerCase();
                                const disc =
                                  parseFloat(v.b2bDiscountValue) || 0;
                                return b2bMode === "percent"
                                  ? base - (disc / 100) * base
                                  : base - disc;
                              })
                              .filter((p) => p !== null && !isNaN(p));

                            const b2cPrices = product.productVariant
                              .map((v) => {
                                const base = parseFloat(v.price);
                                if (isNaN(base)) return null;
                                const b2cMode = (
                                  v.b2cDiscountMode || ""
                                ).toLowerCase();
                                const disc =
                                  parseFloat(v.b2cDiscountValue) || 0;
                                return b2cMode === "percent"
                                  ? base - (disc / 100) * base
                                  : base - disc;
                              })
                              .filter((p) => p !== null && !isNaN(p));

                            const minPrice = variantPrices.length
                              ? Math.min(...variantPrices)
                              : 0;
                            const maxPrice = variantPrices.length
                              ? Math.max(...variantPrices)
                              : 0;
                            const minB2B = b2bPrices.length
                              ? Math.min(...b2bPrices)
                              : 0;
                            const maxB2B = b2bPrices.length
                              ? Math.max(...b2bPrices)
                              : 0;
                            const minB2C = b2cPrices.length
                              ? Math.min(...b2cPrices)
                              : 0;
                            const maxB2C = b2cPrices.length
                              ? Math.max(...b2cPrices)
                              : 0;

                            productPriceDisplay = variantPrices.length
                              ? minPrice === maxPrice
                                ? `₹${minPrice.toFixed(2)}`
                                : `₹${minPrice.toFixed(2)} – ₹${maxPrice.toFixed(2)}`
                              : "0";

                            b2bPriceDisplay = b2bPrices.length
                              ? minB2B === maxB2B
                                ? `₹${minB2B.toFixed(2)}`
                                : `₹${minB2B.toFixed(2)} – ₹${maxB2B.toFixed(2)}`
                              : "0";

                            b2cPriceDisplay = b2cPrices.length
                              ? minB2C === maxB2C
                                ? `₹${minB2C.toFixed(2)}`
                                : `₹${minB2C.toFixed(2)} – ₹${maxB2C.toFixed(2)}`
                              : "0";
                          } else {
                            const price = parseFloat(product.price) || 0;
                            const b2bDiscountValue =
                              parseFloat(product.b2bDiscountValue) || 0;
                            const b2cDiscountValue =
                              parseFloat(product.b2cDiscountValue) || 0;
                            const b2bMode = (
                              product.b2bDiscountMode || ""
                            ).toLowerCase();
                            const b2cMode = (
                              product.b2cDiscountMode || ""
                            ).toLowerCase();

                            const b2bPrice =
                              b2bMode === "percent"
                                ? price - (b2bDiscountValue / 100) * price
                                : price - b2bDiscountValue;

                            const b2cPrice =
                              b2cMode === "percent"
                                ? price - (b2cDiscountValue / 100) * price
                                : price - b2cDiscountValue;

                            productPriceDisplay = `₹${price.toFixed(2)}`;
                            b2bPriceDisplay = `₹${b2bPrice.toFixed(2)}`;
                            b2cPriceDisplay = `₹${b2cPrice.toFixed(2)}`;
                          }

                          return (
                            <tr key={product.id}>
                              <td>
                                <input
                                  type="checkbox"
                                  style={{ borderColor: "#c5d5f5" }}
                                  className="form-check-input"
                                  checked={selectedData.includes(product.id)}
                                  onChange={() => handleSelectOne(product.id)}
                                />
                              </td>
                              <td>{formatProductId(product)}</td>
                              <td>{product.name}</td>
                              <td>{product.categoryName || "N/A"}</td>
                              <td>{product.brandName || "N/A"}</td>
                              <td>{productPriceDisplay}</td>
                              <td>{b2bPriceDisplay}</td>
                              <td>{b2cPriceDisplay}</td>
                              <td style={{ position: "relative" }}>
                                <div className="d-flex gap-1">
                                  <button
                                    style={{
                                      backgroundColor: "#D9EBFF",
                                      height: "36px",
                                      width: "70px",
                                      border: "none",
                                      borderRadius: "4px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      padding: "0",
                                      margin: "0",
                                      fontSize: "14px",
                                      lineHeight: 1,
                                      outline: "none",
                                      fontWeight: "600",
                                      color: "#2B95D3",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      generateProductPDF(product, baseURL);
                                    }}
                                  >
                                    <img
                                      src="/assets/images/download-icon.png"
                                      alt="download"
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        objectFit: "contain",
                                      }}
                                      onError={(e) =>
                                        (e.target.style.display = "none")
                                      }
                                    />
                                    {`\u00A0\u00A0\u00A0PDF`}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            No products found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                  <div className="d-flex align-items-center">
                    <select
                      className="form-select d-inline-block w-auto"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const val = e.target.value;
                        setItemsPerPage(val === "all" ? "all" : parseInt(val));
                        setCurrentPage(1);
                      }}
                      style={{
                        height: "34px",
                        fontSize: "14px",
                        minWidth: "70px",
                      }}
                    >
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="all">All</option>
                    </select>
                    <span className="ms-2">
                      Showing {showingFrom} to {showingTo} of{" "}
                      {filteredData.length} Lists
                    </span>
                  </div>
                  <nav>
                    <ul className="pagination mt-0">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          &laquo;
                        </button>
                      </li>
                      {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(
                          1,
                          currentPage - Math.floor(pagesToShow / 2),
                        );
                        let endPage = startPage + pagesToShow - 1;
                        if (endPage > totalPage) {
                          endPage = totalPage;
                          startPage = Math.max(1, endPage - pagesToShow + 1);
                        }
                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                          pageNumbers.push(i);
                        }
                        return pageNumbers.map((pageNum) => (
                          <li
                            key={pageNum}
                            className={`page-item ${
                              currentPage === pageNum ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => paginate(pageNum)}
                            >
                              {pageNum}
                            </button>
                          </li>
                        ));
                      })()}
                      <li
                        className={`page-item ${
                          currentPage === totalPage ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          &raquo;
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </>
          )}
          <AdminFooter isSidebarMinimized={isSidebarMinimized} />
        </section>
      </div>
    </>
  );
};

export default ReportProduct;

const CustomDropdown = ({ handleDownloadCSV }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Options");
  const dropdownRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  const options = [
    { label: "Export", value: "export" },
    { label: "Export All", value: "exportAll" },
  ];

 const handleSelect = (opt) => {
  setSelected(opt.label);
  setIsOpen(false);
  
  if (opt.value === "export") {
    // ✅ Export = current page only (but selected overrides)
    handleDownloadCSV("current");
  } else if (opt.value === "exportAll") {
    // ✅ Export All = entire dataset (but selected overrides)
    handleDownloadCSV("all");
  }
  
  setSelected("Options");
};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div
      className="custom-select"
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
    >
      <div
        className="select-header"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? "#EDF8FA" : "#fff",
          color: "rgba(129, 134, 134, 1)",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          width: "140px",
          height: "40px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 500,
          transition: "background-color 0.2s ease",
        }}
      >
        <span>{selected}</span>
        <ChevronDown />
      </div>
      {isOpen && (
        <ul
          className="select-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            backgroundColor: "white",
            border: "none",
            borderRadius: "4px",
            zIndex: 1000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: 500,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt)}
              className="select-option"
              style={{
                padding: "8px 12px",
                color: "rgba(129, 134, 134, 1)",
                backgroundColor: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const FilterPanel = ({
  filterValues,
  onFilterChange,
  onApply,
  onClear,
  brands,
  categories,
  products,
  onClick,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "500px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        padding: "16px",
        maxHeight: "500px",
        overflowY: "auto",
        marginTop: "10px",
      }}
      onClick={onClick}
    >
      <div className="row g-3">
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.categoryId}
            onChange={(e) => onFilterChange("categoryId", e.target.value)}
          >
            <option value="">Categories</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.brandId}
            onChange={(e) => onFilterChange("brandId", e.target.value)}
          >
            <option value="">Brand</option>
            {brands.map((brand) => (
              <option key={brand.id} value={brand.id}>
                {brand.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.productId}
            onChange={(e) => onFilterChange("productId", e.target.value)}
          >
            <option value="">Product</option>
            {products.map((product) => (
              <option key={product.id} value={product.id}>
                {product.name}
                {product.brandName ? ` (${product.brandName})` : ""}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="d-flex gap-14 mt-24">
        <button
          onClick={onApply}
          style={{
            color: "#fff",
            backgroundColor: "#2b95d3",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
          }}
        >
          Apply Filters
        </button>
        <button
          onClick={onClear}
          style={{
            color: "#2692d2",
            backgroundColor: "#d9ebff",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
            gap: "6px",
          }}
        >
          Clear All
        </button>
      </div>
    </div>
  );
};